import {Controller} from "@hotwired/stimulus"

/**
 * FilterController allows to filter a list of items by searching through them.
 * It looks for plain string match in the searchable's content
 * (case-insensitive). It accepts a class to toggle on the searchable based
 * on its checkbox state (assumes there's a checkbox input).
 */
export default class extends Controller {
  static classes = ['checked']
  static targets = ['searchable']

  connect() {
    super.connect();
    this.syncCheckStatus();
  }

  search(e) {
    if (e.currentTarget.value.trim() === '') {
      this.searchableTargets.forEach(s => s.hidden = false)
      return
    }

    this.searchableTargets.forEach(s => {
      const text = s.textContent.trim().toLowerCase()
      s.hidden = !text.includes(e.currentTarget.value.trim().toLowerCase())
    })
  }

  syncCheckStatus() {
    this.searchableTargets.forEach(s => {
      s.classList.toggle(this.checkedClass, s.querySelector('input[type=checkbox]').checked)
    });
  }
}